import { Notification } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceNotificationAction, deleteNotificationAction, deleteNotificationsAction, markNotificationsViewedAction, setNotificationsAction } from '../reducers/notificationReducer';

export const useNotificationActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceNotification = (notification: Notification) => {
        dispatch(addOrReplaceNotificationAction(notification));
    }

    const markNotificationsViewed = (notificationIds: string[]) => {
        dispatch(markNotificationsViewedAction(notificationIds));
    }

    const setNotifications = (notifications: Notification[]) => {
        dispatch(setNotificationsAction(notifications));
    }

    const deleteNotification = (notificationId: string) => {
        dispatch(deleteNotificationAction(notificationId));
    }

    const deleteNotifications = (notificationIds: string[]) => {
        dispatch(deleteNotificationsAction(notificationIds));
    }

    return { addOrReplaceNotification, markNotificationsViewed, setNotifications, deleteNotification, deleteNotifications };
}
